import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useMap, GeoJSON } from 'react-leaflet'
import L from 'leaflet'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { makeStyles } from '@material-ui/core/styles'
import { find } from 'lodash'

import { computeColorLabels } from '../../../../utils/gradient'

const useStyles = makeStyles((theme) => ({
    alert: {
        '& .MuiAlert-root': {
            margin: 0,
        },
        '& .MuiAlert-icon': {
            height: theme.spacing(0.5),
        },
        '& .MuiAlert-message': {
            fontSize: theme.spacing(2),
        },
    },
}))

const markerOptions = {
    radius: 3,
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8,
    color: '#03FF03',
}

function ZoneLayer({
    data,
    statisticUnit,
    legend,
    opacity,
    setFeatureData,
}) {
    const classes = useStyles()
    const groupRef = useRef()
    const map = useMap()
    const { t } = useTranslation()
    const [labels, setLabels] = React.useState(
        legend ? computeColorLabels(legend) : null
    )

    const handleClickOnFeature = (e) => {
        setFeatureData(e.feature)
    }

    const onEachFeature = (feature, layer) => {
        var tooltip = null
        var lb = null
        if (feature.properties?.index) {
            tooltip = `<b fontSize: 16px">${
                feature.id
            } - ${feature.properties?.index?.toFixed(2)}</b>`
            lb = find(labels, {
                label: String(feature.properties?.index?.toFixed(2)),
            })
        }
        if (feature?.properties[statisticUnit]) {
            tooltip = `<b fontSize: 16px">${t('zone')} ${
                feature.id
            } <br/> ${statisticUnit}: ${feature.properties[
                statisticUnit
            ]?.toFixed(2)}</b>`
            lb = find(labels, {
                label: String(feature.properties[statisticUnit]?.toFixed(2)),
            })
        }
        layer.bindTooltip(tooltip)

        if (lb)
            layer.setStyle({
                color: lb.color,
                fillColor: lb.color,
                fillOpacity: opacity,
            })
        else if (feature.properties?.color) {
            layer.setStyle({
                color: feature.properties?.color,
                fillColor: feature.properties?.color,
                fillOpacity: opacity,
            })
            layer.on('click', L.bind(handleClickOnFeature, null, layer))
        }
        
    }

    const pointToLayer = (feature, latLng) => {
        return L.circleMarker(latLng, markerOptions)
    }

    React.useEffect(() => {
        map.fitBounds(groupRef.current.getBounds())
    }, [groupRef])

    React.useEffect(() => {
        if (groupRef.current) {
            groupRef.current.clearLayers() // remove old data
            groupRef.current.addData(data) // might need to be geojson.features
        }
    }, [data, statisticUnit])

    return (
        <GeoJSON
            key={statisticUnit}
            data={data}
            name="Zones"
            onEachFeature={onEachFeature}
            pointToLayer={pointToLayer}
            pathOptions={markerOptions}
            ref={groupRef}
        />
    )
}

export default withWidth()(ZoneLayer)
